import { useEffect, useState } from 'react';
import { useAppStore } from '../store/useAppStore';
import { statsApi, Stats } from '../api/stats';
import { FaucetButton } from '../components/FaucetButton';
import { Icon } from '../components/Icon';
import { formatTon } from '../lib/format';

const GAME_NAME: Record<string, string> = {
  crash: 'Ракетка',
  roulette: 'Рулетка',
  dice: 'Dice',
  olympus: 'Олимп',
  doghouse: 'Дом Псов',
  slots: 'Классика',
};

export function ProfileScreen() {
  const setScreen = useAppStore((s) => s.setScreen);
  const balance = useAppStore((s) => s.balance);
  const showToast = useAppStore((s) => s.showToast);

  const [stats, setStats] = useState<Stats | null>(null);
  const [mine, setMine] = useState(true);
  const [lookup, setLookup] = useState('');
  const [busy, setBusy] = useState(false);

  const loadMe = () => {
    statsApi.me().then((s) => {
      setStats(s);
      setMine(true);
    }).catch(() => undefined);
  };
  useEffect(() => {
    loadMe();
  }, []);

  const search = async () => {
    const u = lookup.trim();
    if (!u) return;
    setBusy(true);
    try {
      const s = await statsApi.byUsername(u);
      setStats(s);
      setMine(false);
    } catch (e: any) {
      showToast(e?.response?.data?.message || 'Игрок не найден', true);
    } finally {
      setBusy(false);
    }
  };

  const net = stats ? parseFloat(stats.net) : 0;

  return (
    <div className="stack">
      <div className="profile-head">
        <span className="profile-avatar">
          <Icon name="user" size={26} />
        </span>
        <div className="profile-id">
          <div className="profile-name">{stats?.name ?? 'Профиль'}{mine ? '' : ''}</div>
          {mine && <div className="muted">баланс {formatTon(balance)}</div>}
        </div>
        {mine && <FaucetButton />}
      </div>

      <div className="field">
        <span className="gem" style={{ fontSize: 14 }}>@</span>
        <input
          value={lookup}
          onChange={(e) => setLookup(e.target.value.replace(/[^A-Za-z0-9_@]/g, ''))}
          placeholder="посмотреть профиль игрока"
          onKeyDown={(e) => e.key === 'Enter' && search()}
        />
        <div className="mini-actions">
          <button onClick={search} disabled={busy}>Найти</button>
          {!mine && <button onClick={loadMe}>Я</button>}
        </div>
      </div>

      {stats && (
        <div className="stat-grid">
          <div className="stat-cell">
            <span className="muted">Игр</span>
            <b className="tnum">{stats.total}</b>
          </div>
          <div className="stat-cell">
            <span className="muted">Винрейт</span>
            <b className="tnum">{stats.winrate}%</b>
          </div>
          <div className="stat-cell">
            <span className="muted">Крупнейший</span>
            <b className="tnum" style={{ color: 'var(--green)' }}>+{formatTon(stats.biggestWin)}</b>
            {stats.biggestGame && <span className="muted sm">{GAME_NAME[stats.biggestGame] ?? stats.biggestGame}</span>}
          </div>
          <div className="stat-cell">
            <span className="muted">Профит</span>
            <b className="tnum" style={{ color: net >= 0 ? 'var(--green)' : 'var(--red)' }}>
              {net >= 0 ? '+' : ''}{formatTon(stats.net)}
            </b>
          </div>
          <div className="stat-cell">
            <span className="muted">Побед</span>
            <b className="tnum">{stats.wins}</b>
          </div>
          <div className="stat-cell">
            <span className="muted">Рефералов</span>
            <b className="tnum">{stats.referrals}</b>
          </div>
        </div>
      )}

      {mine && (
        <div className="stack">
          <button className="profile-action" onClick={() => setScreen('transfer')}>
            <span className="pa-ic"><Icon name="send" size={17} /></span>
            <span className="pa-label">Перевести другу</span>
            <span className="pa-arrow"><Icon name="back" size={15} /></span>
          </button>
          <button className="profile-action" onClick={() => setScreen('referral')}>
            <span className="pa-ic"><Icon name="gift" size={17} /></span>
            <span className="pa-label">Пригласить друзей <span className="muted">+250</span></span>
            <span className="pa-arrow"><Icon name="back" size={15} /></span>
          </button>
          <button className="profile-action" onClick={() => setScreen('fairness')}>
            <span className="pa-ic"><Icon name="shield" size={17} /></span>
            <span className="pa-label">Честность <span className="muted">provably fair</span></span>
            <span className="pa-arrow"><Icon name="back" size={15} /></span>
          </button>
        </div>
      )}
    </div>
  );
}
